<div class="product-modal-vanguard">
  <modal-default-mmaxapp>
    <div class="modal-content-wrapper" *ngIf="articulo">
      <button class="modal-close-btn" (click)="closeModal()" aria-label="Close">
        <span class="close-icon">&times;</span>
      </button>

      <div class="modal-grid">
        <!-- Image Section -->
        <div class="image-column">
          <div class="badge-container">
            <div class="badge online" *ngIf="articulo.isdeOferta() && !ocultarPrecios">OFERTA!</div>
            <div class="badge promo" *ngIf="articulo.misPromo && articulo.misPromo.length > 0">
              {{articulo.getPromos()[0].getAbreviaturaPromocion() || articulo.getPromos()[0].getNombrePromocion()}}
            </div>
          </div>
          <div class="product-image-container">
            <img *ngIf="articulo.getImgDownload()" class="modal-product-image" [src]="articulo.getFotoImagen()"
              loading="lazy" [alt]="articulo.getNombreMarca()">
            <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
                 [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
                 [style.opacity]="genServ.getOpacidadMarcadeagua()">
            </div>
          </div>
        </div>

        <!-- Info Section -->
        <div class="info-column">
          <header class="product-header">
            <div class="brand">{{ articulo.getNombreMarca() }}</div>
            <h2 class="title">{{ articulo.getDescripCion() }}</h2>
            <div class="presentation">{{ articulo.getPresentacion() }}</div>
            <div class="tax-info" *ngIf="permiteBultosArticulo()">
              Venta x bulto ({{articulo.getUnidadesPorBulto()}} uxb)
            </div>
          </header>

          <div class="pricing-section" *ngIf="!ocultarPrecios">
            <div class="wholesale-callout" *ngIf="articulo.getCantidadMayorista() > 0">
              <div class="wholesale-info">
                <span class="label">Mayorista:</span>
                <span class="condition">Llevando {{articulo.getCantidadMayorista()}} o más</span>
              </div>
              <span class="price-val">{{articulo.getPrecioMayorista() | currency}} <small>c/u</small></span>
            </div>

            <div class="main-price-row">
              <div class="current-price">
                <span class="currency-symbol">$</span>
                <span class="value">{{(articulo.isdeOferta() ? articulo.getPrecioOferta() : articulo.getPrecio()) |
                  number:'1.2-2'}}</span>
                <span class="unit">c/u</span>
              </div>
              <div class="old-price" *ngIf="articulo.isdeOferta()">
                {{articulo.getPrecio() | currency}}
              </div>
            </div>

            <div class="secondary-info">
              <div class="unit-price" *ngIf="articulo.getPrecioPartido() != -1">
                Precio {{articulo.getOtrosPrecios()}}: <strong>{{articulo.getPrecioPartido() | currency}}</strong>
              </div>
              <div class="tax-info">
                Precio sin impuestos: {{articulo.getPrecioSinImp() | currency}}
              </div>
            </div>
          </div>

          <button type="button" class="descript-button" *ngIf="articulo.getInformacionAdicional()"
            (click)="toggleMasInfo()">
            {{ mostrarMasInfo ? 'Menos info ▲' : 'Más info ▼' }}
          </button>

          <footer class="modal-actions">
            <div class="sumador-wrapper">
              <ng-container class="vanguard-sumador" *ngIf="!permiteBultosArticulo(); else sumadorBultosModal">
                <boton-sumador [fraccion]="articulo.getFraccion()" [unidadMedida]="articulo.getUnidadMedida()"
                  (quantyEvent)="sumaevent($event)" [contador]="articulo.getCantidad()" [modo]="'vanguard'">
                </boton-sumador>
              </ng-container>

              <ng-template #sumadorBultosModal>
                <boton-sumador class="vanguard-sumador" [fraccion]="1" [unidadMedida]="''"
                  (quantyEvent)="sumaeventBultos($event)" [contador]="articulo.getCantidadBultos()" [modo]="'vanguard'">
                </boton-sumador>
              </ng-template>
            </div>
          </footer>
        </div>
      </div>

      <div class="mas-info-section" *ngIf="articulo.getInformacionAdicional()" [class.expanded]="mostrarMasInfo">
        <div class="mas-info-inner">
          <h3>Información adicional</h3>
          <div class="informacion-adicional-content" [innerHTML]="articulo.getInformacionAdicional()"></div>
        </div>
      </div>
    </div>
  </modal-default-mmaxapp>
</div>